import PropTypes from 'prop-types'
import InformationCircle from '@/assets/svgs/information-circle.svg?react'
import StatusBanner from '@/components/StatusBanner/StatusBanner'
import { formatDate } from '@/utils/formatDate'
import { SUBMITTAL_STATUS } from '../constants'

const BANNER_CONFIG = {
  [SUBMITTAL_STATUS.DRAFT]: {
    getPrimary: () => 'Submission is saved as draft',
  },
  [SUBMITTAL_STATUS.PENDING_REVIEW]: {
    getPrimary: () => 'Submission is in pending review',
  },
  [SUBMITTAL_STATUS.APPROVED]: {
    getPrimary: receiverOrgName =>
      `E-Form submission was approved and shared to ${receiverOrgName || 'receiver'}`,
    showBy: true,
  },
  [SUBMITTAL_STATUS.REJECTED]: {
    getPrimary: () => 'Submission was rejected',
    showReasonCard: true,
  },
  [SUBMITTAL_STATUS.REPLACED]: {
    getPrimary: () => 'Submission has been replaced by a newer submission',
    showReasonCard: true,
  },
  [SUBMITTAL_STATUS.DELETED]: {
    getPrimary: () => 'Submission has been deleted',
  },
  [SUBMITTAL_STATUS.PASSED_DEADLINE]: {
    getPrimary: () => 'Submission deadline has passed',
  },
}

export const SubmittalBanner = ({ status, receiverOrgName, latestLog, onViewActivityLog }) => {
  if (!latestLog) return null

  const config = BANNER_CONFIG[status]
  if (!config) return null

  const consultantLabel = latestLog.consultant?.email ?? latestLog.consultant?.name
  const subtitle = [
    config.showBy && consultantLabel ? `by ${consultantLabel}` : null,
    latestLog.created ? `on ${formatDate(latestLog.created)}` : null,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <>
      <StatusBanner
        className="rounded-2xl mt-4 mb-4"
        icon={<InformationCircle />}
        title={config.getPrimary(receiverOrgName)}
        subtitle={subtitle || undefined}
        action={
          onViewActivityLog && (
            <StatusBanner.Action onClick={onViewActivityLog}>
              <span className="sm:hidden">View Log</span>
              <span className="hidden sm:inline">View Activity Log</span>
            </StatusBanner.Action>
          )
        }
      >
        {config.showReasonCard && latestLog.message && (
          <StatusBanner.Note variant="error">
            <StatusBanner.Note.Heading>Reason for rejection:</StatusBanner.Note.Heading>
            <StatusBanner.Note.Body>{latestLog.message}</StatusBanner.Note.Body>
            {consultantLabel && (
              <StatusBanner.Note.Meta>From: {consultantLabel}</StatusBanner.Note.Meta>
            )}
          </StatusBanner.Note>
        )}
      </StatusBanner>
      <hr className="block w-full h-px mb-4 p-0 bg-grey-90 border-none box-border" />
    </>
  )
}

SubmittalBanner.propTypes = {
  status: PropTypes.string,
  receiverOrgName: PropTypes.string,
  latestLog: PropTypes.shape({
    created: PropTypes.string.isRequired,
    message: PropTypes.string,
    created_by: PropTypes.string,
    consultant: PropTypes.shape({ email: PropTypes.string, name: PropTypes.string }),
  }),
  onViewActivityLog: PropTypes.func,
}
